import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { addRefundReason } from "../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
    onComplete: () => void;
}

interface State {
    reason: string;
}

export class RefundReason extends React.Component<Props, State> {
    public state = {
        reason: "",
    };

    protected handleReasonChange = (e: React.FormEvent<HTMLInputElement>): void => {
        this.setState({
            reason: e.currentTarget.value,
        });
    };

    protected handleSave = (): void => {
        if(!this.state.reason.trim()) {
            PopupManager.error("A refund reason is required");

            return;
        }

        this.props.dispatch(addRefundReason(this.state.reason));
        this.props.dispatch(hideDialog());
        this.props.onComplete();
    };

    protected handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if(e.key === "Enter") {
            this.handleSave();
        }
    };

    public render(): React.ReactNode {
        return (
            <div className="add-refund-reason">
                <input
                    value={this.state.reason}
                    onChange={this.handleReasonChange}
                    onKeyDown={this.handleKeyDown}
                    autoFocus
                />
                <div className="buttons">
                    <Button classes={[ "button-save" ]} onClick={this.handleSave}>Save</Button>
                </div>
            </div>
        );
    }
}

export default connector(RefundReason);
